module.exports = __webpack_public_path__ + "static/media/education-object-4-0-1.ef2ee8d2.svg";